import React from 'react';
import { Link } from 'react-router-dom';
import { Capacitor } from '@capacitor/core';

// Shown above the auth card's logo on /login and /register.
//
// Native renders nothing: the app binary has no landing page — App.js maps "/"
// to <Login /> on native — so the link would round-trip back to this same
// screen.
const BackHomeLink = () => {
  if (Capacitor.isNativePlatform()) return null;

  return (
    <div className="auth-back-home">
      <Link to="/" className="auth-link">&larr; Back to home</Link>
    </div>
  );
};

export default BackHomeLink;
